module.exports = __webpack_public_path__ + "static/apple-768a4b7a26a2f5e5655e30ae19be0fb5.png";